import { AppNS } from 'app';
import { RadioQuestion } from 'app/ui/components/radio-questions-list/RadioQuestionsList';

export const checkValidation = (value: RadioQuestion[]) => {
  const checkRecursively = (items: RadioQuestion[]): boolean => {
    for (const item of items) {
      if (item.state === null) {
        return false;
      }

      if (item.children && item.state === item.childrenTriggerValue) {
        if (!checkRecursively(item.children)) {
          return false;
        }
      }
    }
    return true;
  };

  return checkRecursively(value);
};

export const checkFailMatrix = (value: RadioQuestion[], matrix: boolean[] | null[]): boolean => {
  if (!matrix || matrix.length === 0) {
    return false;
  }
  return value.find((item, index) => parseStateToBoolean(item.state) === matrix[index]) ? true : false;
};

const parseRecursively = (
  questions: RadioQuestion[],
  inspectionQuestionnaire: Record<string, string>
): RadioQuestion[] => {
  return questions.map((q) => {
    const result = inspectionQuestionnaire?.[q.id];
    const state = result || null;

    if (q.children) {
      return {
        ...q,
        state,
        children: parseRecursively(q.children, inspectionQuestionnaire),
      };
    }

    return { ...q, state };
  });
};

export const parseQuestionnaire = (report: AppNS.JobEventReport, questionsList: RadioQuestion[]): RadioQuestion[] => {
  if (!report || !report.inspectionQuestionnaire || Object.keys(report.inspectionQuestionnaire).length === 0) {
    return questionsList;
  }

  // rewrite it with recurrency of questionsList in mind. report.inspectionQuestionnaire is always flat. Returned array may be nested

  return parseRecursively(questionsList, report.inspectionQuestionnaire);
};

const flattenQuestions = (questions: RadioQuestion[]): RadioQuestion[] => {
  return questions.reduce((acc: RadioQuestion[], curr: RadioQuestion) => {
    if (curr.children) {
      acc.push(...flattenQuestions(curr.children));
    }
    acc.push(curr);
    return acc;
  }, []);
};

export const parseQuestionnaireOutput = (questionsList: RadioQuestion[]): AppNS.Params => {
  let output: AppNS.Params = {};
  const flatQuestions = flattenQuestions(questionsList);
  flatQuestions.forEach((q) => {
    output[q.id] = q.state === 'yes' ? 'yes' : 'no';
  });

  return output;
};

export const checkIfEditable = (report: AppNS.JobEventReport, canEdit: boolean): boolean => {
  if (!report || !canEdit) {
    return false;
  }

  if (report.inspectionQuestionnaire === null || Object.keys(report.inspectionQuestionnaire).length === 0) {
    return true;
  }

  return false;
};

const parseStateToBoolean = (state: string | null): boolean => {
  return state === 'yes';
};
